import { PicCenterOutlined } from '@ant-design/icons';
import React from 'react';
import { tran } from '../../../../translations/schema/TranslationSchema';
import { IWidgetType } from '../../../IWidgetType';
import { WidgetCategory, WidgetMainType, WidgetType } from '../../../Widget';
import { DividerWidgetComponent } from './DividerWidgetComponent';
import {
  DividerWidgetConfigComponent,
  DividerWidgetConfigSchema,
} from './DividerWidgetConfigComponent';
import type { IDividerWidget } from './IDividerWidget';

/**
 * Tipo del componente di visualizzazione di un divisore per il titolo.
 */
export const DividerWidgetType: IWidgetType<IDividerWidget> = {
  type: WidgetType.Divider,
  mainType: WidgetMainType.Graphic,
  category: WidgetCategory.Graphic,
  name: 'Titolo Divisore',
  icon: <PicCenterOutlined />,
  hasValue: false,
  formComponent: DividerWidgetComponent,
  configComponent: DividerWidgetConfigComponent,
  configValidator: DividerWidgetConfigSchema,
  previewComponent: DividerWidgetComponent,
  translationSchema: tran.widget({
    title: tran.rte(),
  }),
  rules: [],
};
